import { createGate } from 'effector-react';
import { createForm } from '@unicorn/effector-form';
import * as Zod from 'zod';
import { authSubmit } from '@features/common';
import i18n from '@shared/config/i18n';

export const AuthGate = createGate();
export const { open: authPageMounted, close: authPageUnmounted } = AuthGate;

export const authForm = createForm({
  initialValues: {
    login: '',
    password: '',
    isCompany: false,
    remember_me: true,
  },
  validationSchema: Zod.object({
    login: Zod.string().min(1, { message: i18n.t('thisIsRequiredField') as string }),
    password: Zod.string().min(1, { message: i18n.t('thisIsRequiredField') as string }),
  }),
  onSubmit: authSubmit,
  resetOn: authPageUnmounted,
  editable: true,
  sid: 'authForm',
});